import { Component, inject } from '@angular/core';
import { MetadataService } from 'gung-standard';
import { JeevesOpenOrderTableListComponent } from 'gung-standard-jeeves';

@Component({
  selector: 'cult-cult-open-orders-table',
  templateUrl: './cult-open-orders-table.component.html',
  styleUrls: ['./cult-open-orders-table.component.scss'],
  standalone: false
})
export class CultOpenOrdersTableComponent extends JeevesOpenOrderTableListComponent {
  private metadataService = inject(MetadataService);

  getSalespersonMetadata(key: string): string {
    return this.metadataService.getMetadataValue('salj', 'saljarenamn', key) || '-';
  }

  goToPage(url) {
    window
      .open('https://www.dhl.com/se-en/home/tracking/tracking-freight.html?submit=1&tracking-id=' + url, '_blank')
      .focus();
  }
}
